// frontend/src/components/1BAct8.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Spinner, Button } from 'react-bootstrap'; // Import React Bootstrap components for modal message and buttons
import '../App.css'; // Import custom CSS for sticky header
import { APP_API_URL } from '../constants/appURLConstrants';
import FilterPanel from '../searchPannel/FilterPanel_v2';
import { dropdownFieldsByIdx, dropdownOptions, dropdownReverseMap } from '../dropdownMap/1BAct8_dropdownFieldMapping';
import api from '../utils/apiHelper'; // Use the centralized API helper with token handling
import { hasRole } from '../utils/authHelper'; // Import the hasRole function



const FORM_1BACT8_COLUMN_OPTIONS = [
    { label: 'SubmissionID', value: 's.Id' },
    { label: 'HH-ID', value: 'p.HHId' },
    { label: 'ReportingPeriod', value: 's.ReportingPeriod' },
    { label: 'ແຂວງ (Province)', value: 's.province' },
    { label: 'ເມືອງ (District)', value: 's.district' },
    { label: 'ບ້ານ (Village)', value: 's.village' },
    { label: 'ກິດຈະກຳຍ່ອຍ (Sub Activity)', value: 's.subactivity' },
];

export default function Form1BAct8({ refreshTrigger }) {
    const [data, setData] = useState([]);
    const [language, setLanguage] = useState('LA'); // default language
    const [loading, setLoading] = useState(false);
    const [pageSize, setpageSize] = useState(100);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const totalPages = Math.ceil(total / pageSize);

    const [filters, setFilters] = useState([]);
    const [showFilterPanel, setShowFilterPanel] = useState(false);
    const [filterDropdownOptions, setFilterDropdownOptions] = useState({});
    const financialFields = ['IFAD', 'MAF', 'WFP', 'GOL', 'BEN', 'OtherFund'];

    const [isApproveMode, setIsApproveMode] = useState(false);


    // add new
    const [submissionID, setSubmissionID] = useState('');
    const [showContextMenu, setShowContextMenu] = useState(false);
    const [contextMenuPos, setContextMenuPos] = useState({ x: 0, y: 0 });

    const [showModal, setShowModal] = useState(false); // Modal state for data examination
    const [modalData, setModalData] = useState([]); //modal data to display in the popup for examine and edit page

    const [selectedRow, setSelectedRow] = useState({});
    const [selectedUUID, setSelectedUUID] = useState(''); // UUID of submission for the current selected row

    // modal message box state
    const [loadingModalMessage, setLoadingModalMessage] = useState(false);
    const [loadingModalExcelExportMessage, setloadingModalExcelExportMessage] = useState(false); // for modal loading pop state during excel export
    const [modalMessage, setModalMessage] = useState(''); // Message to display in the modal message box as a pop up showing
    const [showSuccessModalMessage, setShowSuccessModalMessage] = useState(false);

    const sessionUser = JSON.parse(sessionStorage.getItem("user"));

    // Fetch main table data
    const fetchData = async (lang, pageNumber = page, limit = pageSize, filters = []) => {
        setLoading(true);
        try {
            const filtersParam = JSON.stringify(filters);
            const res = await api.get(`${APP_API_URL}/api/form1BAct8/getParticipantData`, {
                params: {
                    lang,
                    page: pageNumber,
                    limit,
                    filters: filtersParam
                }
            });
            if (res.data.success) {
                setData(res.data.data.data);
                setTotal(res.data.data.total);
                setPage(res.data.data.page);
            } else {
                setData([]);
                setTotal(0);
                setPage(1);
            }
        } catch (error) {
            console.error('Error fetching form 1BAct8 data:', error);
            setData([]);
        }
        setLoading(false);

    };


    // Fetch modal data for the selected submission
    const fetchModalData = async () => {
        try {
            const res = await api.get(APP_API_URL + `/api/form1BAct8/getParticipantDataBySID?submissionId=${submissionID}&lang=${language}`);
            if (res.data.success) {
                const modalRows = res.data.data;
                setModalData(modalRows);

                // ✅ Automatically select the first row (if any)
                if (modalRows.length > 0) {
                    setSelectedRow(modalRows[0]);
                } else {
                    setSelectedRow({});
                }
            } else {
                setModalData([]);
                setSelectedRow({});
            }
        } catch (error) {
            console.error('Error fetching modal data:', error);
            setModalData([]);
            setSelectedRow({});
        }
    };






    useEffect(() => {
        const DROPDOWN_COLUMNS = ['province', 'district', 'village', 'subactivity'];
        Promise.all(
            DROPDOWN_COLUMNS.map(col =>
                api.get(`${APP_API_URL}/api/form1BAct8/getDistinctValues?column=${col}`)
                    .then(res => ({ col, data: res.data.success ? res.data.data : [] }))
                    .catch(() => ({ col, data: [] }))
            )
        ).then(results => {
            const opts = {};
            results.forEach(({ col, data: rows }) => {
                opts[`s.${col}`] = rows.map(r => ({
                    value: r.code,
                    label: language === 'LA' ? (r.label_lao || r.code) : (r.label_en || r.code)
                }));
            });
            setFilterDropdownOptions(opts);
        });
    }, [language]);

    // Load data on mount and when language or mode changes
    useEffect(() => {
        const modeFilter = {
            column: 's.approval_status',
            condition: isApproveMode ? 'notEquals' : 'equals',
            value: 'approved'
        };
        const effectiveFilters = [modeFilter, ...filters];

        if (filters.length > 0 || isApproveMode) {
            setPage(1);
            fetchData(language, 1, 9999999, effectiveFilters);
        } else {
            fetchData(language, page, pageSize, effectiveFilters);
        }
    }, [language, refreshTrigger, page, pageSize, filters, isApproveMode]);

    //Langauge toggle function
    const toggleLanguage = () => {
        setLanguage((prev) => (prev === 'LA' ? 'EN' : 'LA'));
    };

    const handleDeleteSubmission = async () => {
        if (!submissionID) {
            alert('Please select a submission to delete.');
            return;
        }
        if (!window.confirm(`Are you sure you want to delete submission ID: ${submissionID}? This will remove all associated data.`)) return;
        try {
            setLoadingModalMessage(true);
            const response = await api.delete(APP_API_URL + `/api/form1BAct8/deleteSubmission?submissionId=${submissionID}`);
            if (response.data.success) {
                setModalMessage('✅ Submission deleted successfully');
                setShowSuccessModalMessage(true);
                refreshAfterAction();
                closeModal();
            } else {
                setModalMessage('❌ Failed to delete submission');
                setShowSuccessModalMessage(true);
            }
        } catch (error) {
            console.error('Error deleting submission:', error);
            const errorMsg = error.response?.data?.error || error.response?.data?.message || error.message || 'Unknown error';
            setModalMessage(`❌ Error deleting submission: ${errorMsg}`);
            setShowSuccessModalMessage(true);
        } finally {
            setLoadingModalMessage(false);
        }
    }

    const handleSubmissionUUID = async () => {
        if (!submissionID) {
            alert('Please select a submission to get UUID.');
            return;
        }

        try {
            const response = await api.get(APP_API_URL + `/api/form1BAct8/getUUID?submissionId=${submissionID}`);
            if (response.data.success) {
                const uuid = response.data.uuid;
                setSelectedUUID(uuid);
                return uuid; // ✅ Return the UUID
            } else {
                alert('Failed to fetch UUID');
                return null;
            }
        } catch (error) {
            console.error('Error fetching UUID:', error);
            alert('Error fetching UUID');
            return null;
        }

    }


    // Cell click/right-click handlers for data table
    const handleCellClick = (row) => {
        setSubmissionID(row[Object.keys(row)[1]]);

    };

    const handleContextMenu = (e, row) => {
        e.preventDefault();
        setSubmissionID(row[Object.keys(row)[1]]);
        setContextMenuPos({ x: e.pageX, y: e.pageY });
        setShowContextMenu(true);
    };

    // Context menu Examine item click handlers
    const handleExamine = () => {
        setShowContextMenu(false);
        handleSubmissionUUID(submissionID); // Get UUID for the selected submission
        fetchModalData();
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setModalData([]);
        setSelectedRow({});
    };

    //cb for staff export to Excel
    const handleExcelExport = async () => {
        try {
            setloadingModalExcelExportMessage(true); //for modal Exporting pop state
            const response = await api.get(APP_API_URL + `/api/form1BAct8/exportToExcel?lang=${language}`, {
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Form_1BAct8_Exported_Report.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Export failed', error);
            alert('Form 1BAct8 Export to Excel failed');
        } finally {
            setloadingModalExcelExportMessage(false); //for modal Exporting pop state
        }
    };


    // Button: Load new data — resets to normal (approved-only) mode
    const handleDownloadForm1BAct8bDataFromKobo = async () => {
        try {
            setLoadingModalMessage(true);
            const response = await api.get(`${APP_API_URL}/api/form1BAct8/downloadFromKoboToolbox`);
            if (response.data.success) {
                setModalMessage('✅ Operation completed successfully!');
                setShowSuccessModalMessage(true);
                setIsApproveMode(false);
                setFilters([]);
                fetchData(language, page, pageSize, [{ column: 's.approval_status', condition: 'equals', value: 'approved' }]);
            } else {
                setModalMessage('❌ Failed to download Form 1BAct8 data from KoboToolbox');
                setShowSuccessModalMessage(true);
            }
        } catch (error) {
            console.error('Error downloading Form 1BAct8 data from KoboToolbox:', error);
            setModalMessage('❌ Error downloading Form 1BAct8 data from KoboToolbox');
            setShowSuccessModalMessage(true);
        } finally {
            setLoadingModalMessage(false);
        }
    }

    // Download data from KoboToolbox and filter to unapproved records only
    const handleApproveData = async () => {
        try {
            setLoadingModalMessage(true);
            const response = await api.get(`${APP_API_URL}/api/form1BAct8/downloadFromKoboToolbox`);
            if (response.data.success) {
                setModalMessage('✅ Operation completed successfully!');
                setShowSuccessModalMessage(true);
                setIsApproveMode(true);
                setFilters([]);
            } else {
                setModalMessage('❌ Failed to download Form 1BAct8 data from KoboToolbox');
                setShowSuccessModalMessage(true);
            }
        } catch (error) {
            console.error('Error downloading Form 1BAct8 data from KoboToolbox:', error);
            setModalMessage('❌ Error downloading Form 1BAct8 data from KoboToolbox');
            setShowSuccessModalMessage(true);
        } finally {
            setLoadingModalMessage(false);
        }
    }

    // Reload table respecting current mode
    const refreshAfterAction = (lang = language) => {
        const modeFilter = {
            column: 's.approval_status',
            condition: isApproveMode ? 'notEquals' : 'equals',
            value: 'approved'
        };
        if (isApproveMode) {
            fetchData(lang, 1, 9999999, [modeFilter]);
        } else {
            fetchData(lang, page, pageSize, [modeFilter]);
        }
    };

    const syncFromKobo = async () => {
        await api.get(`${APP_API_URL}/api/form1BAct8/downloadFromKoboToolbox`);
    };

    const handleApproveSubmission = async () => {
        if (!submissionID) {
            alert('Please select a submission to approve.');
            return;
        }
        if (!window.confirm(`Approve submission ID: ${submissionID}?`)) return;
        try {
            setLoadingModalMessage(true);
            const response = await api.post(`${APP_API_URL}/api/form1BAct8/approveSubmission`, {
                submissionId: submissionID,
                approvedBy: sessionUser?.username || 'Unknown User'
            });
            if (response.data.success) {
                setModalMessage('✅ Submission approved successfully');
                setShowSuccessModalMessage(true);
                closeModal();
                refreshAfterAction();
            } else {
                setModalMessage('❌ Failed to approve submission');
                setShowSuccessModalMessage(true);
            }
        } catch (error) {
            console.error('Error approving submission:', error);
            setModalMessage(`❌ Error approving submission: ${error.response?.data?.error || error.message}`);
            setShowSuccessModalMessage(true);
        } finally {
            setLoadingModalMessage(false);
        }
    };



    // ✅ Helper: get new submissionId by UUID and refresh modal data
    const refreshModalWithNewSubmission = async (uuid, language) => {
        if (!uuid) {
            alert("UUID is empty.");
            return;
        }

        try {
            // Step 1: get the new submissionId
            const response = await api.get(APP_API_URL + `/api/form1BAct8/getNewSubmissionID?Uuid=${uuid}`);


            if (response.data.success) {
                const newSubmissionId = response.data.newSubmissionId;
                setSubmissionID(newSubmissionId);
                //alert(`New submission ID: ${newSubmissionId}`);

                // Step 2: fetch modal data for this new submissionId
                const res = await api.get(
                    APP_API_URL + `/api/form1BAct8/getParticipantDataBySID?submissionId=${newSubmissionId}&lang=${language}`
                );

                if (res.data.success) {
                    const modalRows = res.data.data;
                    setModalData(modalRows);

                    // Auto-select first row
                    if (modalRows.length > 0) {
                        setSelectedRow(modalRows[0]);
                    } else {
                        setSelectedRow({});
                    }
                } else {
                    setModalData([]);
                    setSelectedRow({});
                }

                return true;



            } else {
                alert("Failed to fetch new submission ID");
                return false;
            }
        } catch (error) {
            console.error("Error refreshing modal:", error);
            setModalData([]);
            setSelectedRow({});

            return false;
        }
    };


    const handleDeleteParticipant = async (participantId, submissionId) => {
        if (!participantId || !submissionId) {
            alert('Please select a participant and submission to delete.');
            return;
        }
        if (!window.confirm(`Are you sure you want to delete participant ID: ${participantId} from submission ID: ${submissionId}?`)) return;
        const uuid = await handleSubmissionUUID();
        try {
            setLoadingModalMessage(true);
            const response = await api.post(`${APP_API_URL}/api/form1BAct8/deleteParticipant`, { participantId, submissionId });
            if (response.data.success) {
                setModalMessage('✅ Participant deleted successfully');
                setShowSuccessModalMessage(true);
                await syncFromKobo();
                refreshAfterAction();
                if (uuid) await refreshModalWithNewSubmission(uuid, language);
            } else {
                setModalMessage('❌ Failed to delete participant');
                setShowSuccessModalMessage(true);
            }
        } catch (error) {
            console.error('Error deleting participant:', error);
            const errorMsg = error.response?.data?.error || error.response?.data?.message || error.message || 'Unknown error';
            setModalMessage(`❌ Error deleting participant: ${errorMsg}`);
            setShowSuccessModalMessage(true);
        } finally {
            setLoadingModalMessage(false);
        }
    }

    const handleEditSubmissionAndParticipants = async () => {
        if (!window.confirm(`Are you sure you want to edit the selected participant?`)) return;
        const uuid = await handleSubmissionUUID();
        try {
            let dataToSubmit = { ...selectedRow };

            Object.entries(dataToSubmit).forEach(([key, val], idx) => {
                const fieldName = dropdownFieldsByIdx[idx];
                if (fieldName) {
                    const internalVal = dropdownReverseMap[fieldName][language][val];
                    if (internalVal) {
                        dataToSubmit[key] = internalVal;
                    }
                }
            });

            setLoadingModalMessage(true);
            const response = await api.post(`${APP_API_URL}/api/form1BAct8/updateParticipantAndSubmissionData`, dataToSubmit);
            if (response.data.success) {
                setModalMessage('✅ Participant data updated successfully');
                setShowSuccessModalMessage(true);
                await syncFromKobo();
                refreshAfterAction();
                if (uuid) await refreshModalWithNewSubmission(uuid, language);
            } else {
                setModalMessage('❌ Failed to update record');
                setShowSuccessModalMessage(true);
            }
        } catch (err) {
            console.error('Error updating record:', err);
            const errorMsg = err.response?.data?.error || err.response?.data?.message || err.message || 'Unknown error';
            setModalMessage(`❌ Error updating record: ${errorMsg}`);
            setShowSuccessModalMessage(true);
        } finally {
            setLoadingModalMessage(false);
        }
    }

    //function to validate datetime to a valid ISO date string like "2025-08-20"
    function isValidDate(dateString) {
        return /^\d{4}-\d{2}-\d{2}$/.test(dateString);
    }






    // ########################################## Main return function ##########################################
    return (
        <div onClick={() => setShowContextMenu(false)}>

            {/* Header */}
            <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="text-center w-100">
                    <div className="fw-bold fs-5">1B-Act 8: ປັບປຸງພື້ນຖານໂຄງລ່າງກະສິກຳ ເພື່ອການປັບຕົວຕໍ່ການປ່ຽນແປງດິນຟ້າອາກາດ</div>
                    <div>Climate Change Adaptation infrastructures (irrigation /MUS) built and upgraded</div>
                </div>

                {/* Language switchig button between LA and EN */}
                <div className="position-absolute end-0 me-4">
                    <button className="btn btn-warning btn-sm" onClick={toggleLanguage}> {language === 'LA' ? 'EN' : 'LA'}</button>
                </div>
            </div>


            {/* Buttons */}
            <div className="d-flex justify-content-between mb-2">
                <div className="d-flex align-items-center flex-wrap">
                    {hasRole("ADMIN") && (
                        <>
                            <button className='btn btn-primary btn-sm me-2' style={{ width: '170px', whiteSpace: 'nowrap' }} onClick={handleDownloadForm1BAct8bDataFromKobo} title='To cleanup application database and reload new data from KoboToolbox online database'>Load new data</button>
                            <button className='btn btn-primary btn-sm me-2' style={{ width: '170px', whiteSpace: 'nowrap' }} onClick={handleApproveData} title='To show list of unapproved data and validate'>Show unapproved data</button>
                        </>
                    )}
                    <button className='btn btn-primary btn-sm me-2' style={{ width: '170px', whiteSpace: 'nowrap' }} onClick={handleExcelExport} title='To export the data to Excel template file'>Export</button>
                    <button className='btn btn-primary btn-sm' style={{ width: '170px', whiteSpace: 'nowrap' }} onClick={() => setShowFilterPanel(!showFilterPanel)} title='To show or hide filter for the search result'>Filter</button>
                    {showFilterPanel && (
                        <div className="ms-2">
                            <FilterPanel
                                filters={filters}
                                setFilters={setFilters}
                                columnOptions={FORM_1BACT8_COLUMN_OPTIONS}
                                dropdownValueOptions={filterDropdownOptions}
                            />
                        </div>
                    )}

                    {/* Showing unapproved data notification message */}
                    {isApproveMode && (
                        <div className="ms-2">
                            <span className="text-danger fw-bold"> * Showing unapproved data only - Please review and approve to move data to the main list</span>
                        </div>
                    )}
                </div>
            </div>

            {/* Hidden input */}
            <input type="hidden" id="txt_submissionID" value={submissionID} readOnly />
            <input type="hidden" id="txt_selectedUUID" value={selectedUUID} readOnly />




            {/* Modal Message for loading wait progresss with spinner*/}
            <Modal show={loadingModalMessage} centered backdrop="static">
                <Modal.Body className="text-center">
                    <Spinner animation="border" role="status" className="mb-2">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                    <div>Loading new data from KoboToolbox...</div>
                </Modal.Body>
            </Modal>
            {/* Modal Message for loading Success*/}
            <Modal show={showSuccessModalMessage} onHide={() => setShowSuccessModalMessage(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Transaction status:</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalMessage}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => setShowSuccessModalMessage(false)}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>


            {/* Modal Message for exporting excel file wait progresss with spinner*/}
            <Modal show={loadingModalExcelExportMessage} centered backdrop="static">
                <Modal.Body className="text-center">
                    <Spinner animation="border" role="status" className="mb-2">
                        <span className="visually-hidden">Exporting...</span>
                    </Spinner>
                    <div>Exporting data to Excel file...</div>
                </Modal.Body>
            </Modal>




            {/* Main Table */}
            {loading ? (
                <div>Loading...</div>
            ) : (
                <div>
                    <div className="table-responsive" style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 'calc(100vh - 390px)' }}>
                        <table className="table table-bordered table-hover table-sm text-nowrap">
                            <thead className="table-success sticky-header">
                                {data.length > 0 && (
                                    <tr>
                                        {Object.keys(data[0]).map((col) => (
                                            <th key={col}>{col}</th>
                                        ))}
                                    </tr>
                                )}
                            </thead>
                            <tbody>
                                {data.map((row, rowIdx) => (
                                    <tr
                                        key={rowIdx}
                                        className={row === selectedRow ? 'table-warning' : ''}
                                        onClick={() => {
                                            setSelectedRow(row);
                                            handleCellClick(row);
                                        }}
                                        onContextMenu={(e) => handleContextMenu(e, row)}
                                    >
                                        {Object.entries(row).map(([col, value], colIdx) => (
                                            <td key={col}>
                                                {(colIdx >= 20 && colIdx <= 27 && !isNaN(value))
                                                    ? Number(value).toLocaleString()
                                                    : value}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        {total > 0 && filters.length === 0 && (
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <div>
                                    Showing page {Number.isInteger(page) ? page : 1} of {Number.isFinite(totalPages) ? totalPages : 1} ({total} records)
                                </div>
                                <div className="btn-group">
                                    <button
                                        className="btn btn-sm btn-outline-secondary"
                                        disabled={page <= 1 || page === undefined}
                                        onClick={() => {
                                            const newPage = page - 1;
                                            setPage(newPage);
                                            fetchData(language, newPage, pageSize);
                                        }}
                                    >
                                        Previous
                                    </button>
                                    <button
                                        className="btn btn-sm btn-outline-secondary"
                                        disabled={page >= totalPages || page === undefined}
                                        onClick={() => {
                                            const newPage = page + 1;
                                            setPage(newPage);
                                            fetchData(language, newPage, pageSize);
                                        }}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}


            {/* Context Menu */}
            {showContextMenu && (
                <ul
                    className="custom-context-menu"
                    style={{
                        top: contextMenuPos.y,
                        left: contextMenuPos.x,
                        position: 'absolute',
                        zIndex: 1000,
                        backgroundColor: '#fff',
                        border: '1px solid #ccc',
                        padding: '5px',
                        listStyle: 'none'
                    }}
                    onMouseLeave={() => setShowContextMenu(false)}
                >
                    <li style={{ cursor: 'pointer' }} onClick={handleExamine}>Examine</li>
                    {isApproveMode && (<li style={{ cursor: 'pointer', color: '#155724', fontWeight: 'bold' }} onClick={() => { setShowContextMenu(false); handleApproveSubmission(); }}>Approve</li>)}
                </ul>
            )}



            {/* Main Modal for data edition popup*/}
            {showModal && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }}>
                    <div className="mmodal-dialog modal-dialog-scrollable modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header" style={{ backgroundColor: '#7de2d1' }}>
                                <h5 className="modal-title">Submission ID: {submissionID}</h5>
                                <button type="button" className="btn-close" onClick={closeModal}></button>
                            </div>
                            <div className="modal-body" >


                                {/* Modal Textboxes for data edit with textbox size customized and make new line starting from textbox index 14*/}
                                {selectedRow && Object.keys(selectedRow).length > 0 && (
                                    <div className="row">
                                        {Object.entries(selectedRow).map(([key, value], idx) => {
                                            let colClass = 'col-lg-2'; // default column size

                                            if ((idx >= 0 && idx <= 7) || (idx >= 11 && idx <= 17) || (idx === 19) || (idx >= 23 && idx <= 28)) {
                                                colClass = 'col-lg-1';
                                            } //else if ( idx === 13) {
                                            //colClass = 'col-lg-3';
                                            //}

                                            const needsNewLine = (idx === 29);

                                            const isDateField = idx >= 3 && idx <= 5;
                                            //const isEditableText = (idx >= 11 && idx <= 7) || (idx >= 13 && idx <= 18);
                                            const isEditableText = (idx === 10) || (idx === 13);
                                            const isNumericField = (idx >= 22 && idx <= 29) || (idx === 14) || (idx === 19);

                                            const dropdownFieldName = dropdownFieldsByIdx[idx];
                                            const isDropdown = Boolean(dropdownFieldName);

                                            return (
                                                <React.Fragment key={idx}>
                                                    {needsNewLine && <div className="w-100"></div>}

                                                    <div className={`${colClass} mb-3`}>
                                                        <label className="form-label text-start w-100 fw-bold fs-6" style={{ color: '#001d3d' }}> {key + ":"}</label>

                                                        {isDropdown ? (
                                                            <select
                                                                className="form-control form-control-sm"
                                                                value={value ?? ''}
                                                                onChange={(e) =>
                                                                    setSelectedRow((prev) => ({
                                                                        ...prev,
                                                                        [key]: e.target.value
                                                                    }))
                                                                }
                                                            >
                                                                {dropdownOptions[dropdownFieldName].internal.map((internalVal) => (
                                                                    <option key={internalVal} value={dropdownOptions[dropdownFieldName][language][internalVal]}>
                                                                        {dropdownOptions[dropdownFieldName][language][internalVal]}
                                                                    </option>
                                                                ))}
                                                            </select>

                                                        ) : isDateField ? (
                                                            <input
                                                                type="date"
                                                                className="form-control form-control-sm"
                                                                value={isValidDate(value) ? value.slice(0, 10) : ''}
                                                                onChange={(e) =>
                                                                    setSelectedRow((prev) => ({
                                                                        ...prev,
                                                                        [key]: e.target.value,
                                                                    }))
                                                                }
                                                            />
                                                        ) : isNumericField ? (
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-sm"
                                                                value={value ?? ''}
                                                                onChange={(e) =>
                                                                    setSelectedRow((prev) => ({
                                                                        ...prev,
                                                                        [key]: e.target.value,
                                                                    }))
                                                                }
                                                            />
                                                        ) : isEditableText ? (
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={value ?? ''}
                                                                onChange={(e) =>
                                                                    setSelectedRow((prev) => ({
                                                                        ...prev,
                                                                        [key]: e.target.value,
                                                                    }))
                                                                }
                                                            />
                                                        ) : (
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={value ?? ''}
                                                                readOnly
                                                            />
                                                        )}
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                )}


                                {/* Modal action buttons */}

                                {/* <div className="modal-footer d-flex justify-content-start ">
                                    <button className="btn btn-warning" style={{ width: '160px' }} title="To edit the selected record of data">Edit Record</button>
                                    <button className="btn btn-danger" style={{ width: '160px' }} title="To delete only the selected record of data">Delete Participant</button>
                                    <button className="btn btn-danger" style={{ width: '160px' }} title="To delete all records of data for this submission">Delete Submission</button>
                                    <button className="btn btn-secondary" style={{ width: '160px' }} onClick={closeModal} >Close</button>
                                </div> */}
                                {/* Check if ADMIN then show Modal action buttons */}
                                {hasRole("ADMIN") && (
                                    <>
                                        <div className="modal-footer d-flex justify-content-start flex-wrap">
                                            <button className="btn btn-warning" style={{ width: '160px' }} onClick={handleEditSubmissionAndParticipants} title="To edit the selected record of data">Edit Record</button>
                                            <button className="btn btn-danger" style={{ width: '160px' }} onClick={() => handleDeleteParticipant(selectedRow.PID, selectedRow.SubmissionID)} title="To delete only the selected record of data">Delete Participant</button>
                                            <button className="btn btn-danger" style={{ width: '160px' }} onClick={handleDeleteSubmission} title="To delete all records of data for this submission">Delete Submission</button>
                                            {isApproveMode && (
                                                <button className="btn btn-success" style={{ width: '160px' }} onClick={handleApproveSubmission} title="Mark this submission as approved">Approve</button>
                                            )}
                                            <button className="btn btn-secondary" style={{ width: '160px' }} onClick={closeModal} >Close</button>
                                        </div>
                                    </>
                                )}

                                {/* Modal Table */}
                                <div className="table-responsive mb-3" style={{ maxHeight: 'calc(100vh - 560px)', overflowY: 'auto' }}>
                                    <table className="table table-bordered table-hover table-sm text-nowrap">
                                        <thead className="table-info">
                                            {modalData.length > 0 && (
                                                <tr>
                                                    {Object.keys(modalData[0]).map((col) => (
                                                        <th key={col}>{col}</th>
                                                    ))}
                                                </tr>
                                            )}
                                        </thead>
                                        <tbody>
                                            {modalData.map((row, idx) => (
                                                <tr
                                                    key={idx}
                                                    onClick={() => setSelectedRow(row)}
                                                    className={row === selectedRow ? 'table-warning' : ''}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {Object.entries(row).map(([col, value], colIdx) => (
                                                        <td key={col}>
                                                            {(colIdx >= 21 && colIdx <= 25 && !isNaN(value))
                                                                ? Number(value).toLocaleString()
                                                                : value}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* End of Modal */}


        </div>

        //End of return
    );

    //End of default function
}